import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function LoadingScreen() {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#0A2342',
        zIndex: 9999,
        animation: 'authra-fade-in 0.25s ease-out',
        '@keyframes authra-fade-in': {
          from: { opacity: 0, transform: 'translateY(8px)' },
          to:   { opacity: 1, transform: 'translateY(0)' },
        },
      }}
    >
      <CircularProgress
        size={48}
        thickness={3}
        sx={{ color: '#C9A84C', mb: 3 }}
      />
      <Typography
        sx={{
          color: '#fff',
          fontSize: 26,
          fontWeight: 800,
          letterSpacing: '0.06em',
        }}
      >
        Authra
      </Typography>
    </Box>
  );
}
